<template>
	<div class="container">
		<div class="news-detail">
			<div class="nd-body">
				<div class="bread-nav">
					<span @click="navgoTo()">全部</span> > 工作技巧 > <span class="txt-gray">{{objData.title}}</span>
				</div>
				<div class="nd-body-content">
					<div class="nd-body-view">
						<div class="nd-body-view-title">{{objData.title}}</div>
						<div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 工作技巧</div>
						<div class="nd-body-view-content">{{objData.content}}</div>
						<div class="nd-body-view-content">
							<img src="../../../static/Bitmap_3.jpg" alt="map"/>
						</div>

						<div class="nd-body-view-content">
							<a href="https://www.abopin.com/webFile/2019/09/19/06/6716e3fbc7cdb279f8b95e1ccc2a6ffd/zip/unknown-4e93-1568875392545.zip">13个沟通技巧文件</a>
							<!-- <h3 class="nd-body-view_h3">{{objData.subtitle}}</h3>
							<div>{{objData.contenta}}</div>
							<div>{{objData.contenta1}}</div>
							<div>{{objData.contenta2}}</div> -->
						</div>
						<!-- <div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitleb}}</h3>
							<div>{{objData.contentb1}}</div>
							<div>{{objData.contentb2}}</div>
							<div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div>
						</div> -->
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitlec}}</h3>
							<div>{{objData.contentc1}}</div>
							<div>{{objData.contentc2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-content">
							<h3 class="nd-body-view_h3">{{objData.subtitled}}</h3>
							<div>{{objData.contentd1}}</div>
							<div>{{objData.contentd2}}</div>
							<!-- <div>{{objData.contentb3}}</div>
							<div>{{objData.contentb4}}</div> -->
						</div>
						<div class="nd-body-view-of">
							<div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
							<div>下一篇：{{objData.next}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ShowNewsDetail',
		data(){
			return {
				id:'',
				objData:{
					title:`13个高效沟通技巧助你成为HR沟通高手`,
					date:`2019年9月19日`,
					froms:`播聘`,
					next:`播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
					prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
					content:`HR作为企业招聘的核心岗位，无论是对公司人才招聘还是人才梯队建设，都起着至关重要的作用，制造新鲜血液，处理人事关系，高效的沟通技巧是一个HR高手必备的技能，本期播聘工作技巧带你晋级，13个高效沟通技巧干货请收下！`,
					// subtitle:`播聘，一个颠覆传统招聘方式的平台`,
					// contenta:`2019年6月6日，工信部正式向中国电信、中国移动、中国联通、中国广电发放5G商用牌照。我国正式进入5G商用元年。`,
					// contenta1:`4G改变生活，5G改变社会。播聘平台顺应5G的时代趋势而生。作为目前唯一的大数据视频招聘生活社交服务平台，播聘全心致力于“让天下没有难招的工，没有失业的人”的伟大事业。目前国内业务主要集中在全国一线城市及各个省会城市，未来还会扩展至全球数十个重要的地区和国家。`,
					// contenta2:`与传统招聘平台不同的是，播聘结合大数据、云计算、用户画像等技术开创的视频简历与视频面试的生活新方式，是人工智能时代对招工方式的一次颠覆与创新。`,

					// subtitleb:`求职招聘，就用播聘`,
					// contentb1:`对企业来说，播聘平台会通过数据分析，为企业各招聘部门推送岗位匹配的求职者视频简历，在阅读简历阶段就能对求职者的个人形象、表达能力进行了解，为HR节省海量筛选简历的时间，提高招聘效率。`,
					// contentb2:`另一方面，企业不仅可以在播聘平台上发布岗位要求和招工信息，还可以上传视频到平台以呈现公司的企业文化、工作环境、工作氛围等，有助于求职者直观、全面地了解企业，吸引志同道合的伙伴，同时增加企业关注度和影响力。`,
					// contentb3:`对求职者来说，播聘平台倡导“秀出真我”，求职者通过视频简历可以直观地展现工作技能、兴趣爱好、个人性格，有效突破文字简历的平面性和局限性，同时提高个人简历的吸引力和价值。`,
					// contentb4:`播聘平台通过系统数据分析求职者的求职意向，精准推送与之匹配的岗位，企业在看过求职者的视频简历后，即可在线视频面试，不仅大幅度降低求职者的时间成本，而且提升了求职成功率。`,

					// subtitlec:`播聘，零工经济的驱动者`,
					// contentc1:`在经济发展和政策措施的带动下，我国就业结构不断优化，就业质量显著提升。“人尽其才，才尽其用”是企业和求职者的共同追求。在这一追求的驱动下，零工经济将成为就业新增长点。`,
					// contentc2:`播聘不仅是视频招聘方式的开创者，而且是人力资源共享模式的引领者，它为临工、短工、钟点工、项目合作人员等提供了一个人才资源共享的平台，帮助企业降低用工成本，充分调动各类人才创造活力发挥自身价值，让“智者尽其谋、勇者竭其力、仁者播其惠、信者效其忠”。`,
					
					// subtitled:`播聘，不只是一个招聘平台`,
					// contentd1:`播聘平台除了提供视频简历、远程面试、视频全息培训等视讯化服务，还提供一系列周边服务，如公司招聘广告片制作、大学生求职视频包装、企业培训课程视频录制剪辑 + VR全息平台提供、求职者包装教育课堂等，是一个综合性社会化服务平台。`,
					// contentd2:`雪莱在《西风颂》中曾说过：如果冬天来了，春天还会远吗？在“经济寒冬”的浪潮下，播聘将搭建起企业和求职者沟通的桥梁，让企业和求职者各取所需、共同发展，为中国的人力资源行业贡献一份力，为中国经济创造新奇迹增添一份彩！`,
				}
			}
		},
		created(option) {
			this.init()
		},
		methods:{
			init(){
				let _this = this;
				_this.id = _this.$route.query.id || ``;
				
			},
			navgoTo(){
				this.$nav({path:`/show-news`},this)
			}
		}
	}
</script>

<style scoped="scoped">
	@import url("./show-acrobatics.css");
</style>



// WEBPACK FOOTER //
// src/pages/show-acrobatics/show-acrobatics.vue